// extracted by mini-css-extract-plugin
module.exports = {"explaination":"SendInvitationModal_explaination_KDQ5A"};